import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {InventoryItemExtensionContainerModel} from '../../../../../../models/aggregates/erp/inventory';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class InventoryItemExtService extends BaseApiTemplateService<InventoryItemExtensionContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + "inv-items/exts";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + "inv-items/exts";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + "inv-items/exts";
    this.httpClient = http;
  }

}


